<!--  -->
<template>
  <div class="Contact_Us">
    <div class="contact-form">
      <h1>Contact Us</h1>
      <h1>{{ touzizhe }}</h1>
      <div class="contact-input">
        <el-select
          class="selectInput"
          name="Prefix"
          v-model="value1"
          placeholder="Prefix"
        >
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <input type="text" v-model="name" name="Name" placeholder="Name" />
        <input
          type="text"
          name="Hospital"
          v-model="Hospital"
          class="Hospital"
          placeholder="Hospital/Company"
        />
        <input
          type="text"
          name="City"
          v-model="City"
          placeholder="City & State"
        />
        <input
          type="text"
          name="Country"
          v-model="Country"
          placeholder="Country"
        />
        <input type="text" name="Email" v-model="email" placeholder="Email" />
        <input
          type="text"
          name="Phone"
          v-model="phone"
          placeholder="Phone Number"
        />
        <el-select
          class="selectInput"
          v-model="value2"
          name="Inquiry"
          placeholder="Type of Inquiry"
        >
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <textarea
          class="liuyan"
          v-model="msg"
          type="text"
          name="Comment"
          placeholder="Comment or Message"
        />

        <el-select
          class="selectInput"
          v-model="value3"
          name="Contacted"
          placeholder="How do you Prefer to be Contacted?"
        >
          <el-option
            v-for="item in options3"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div
        class="g-recaptcha"
        data-sitekey="6LcpHSMdAAAAAIx301I1ulrCBObKaYM11nmDT1uy"
      ></div>
      <input class="submit" value="Submit" type="button" @click="submit" />

      <div class="contact-hint">
        <h1>{{ hint1 }}</h1>
        <!-- <h1>{{ hint2 }}</h1> -->
      </div>
    </div>
  </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      xm: "",
      yx: "",
      dh: "",
      ly: "",
      touzizhe: "", //投资者联络
      tijiao: "", //提交
      hint1: "", //如您有任何疑问，可随时通过专用电子邮箱 ir@broncuschina.com联络我们。
      hint2: "", //谢谢您的关注和支持！
      name: "",
      City: "",
      Country: "",
      Hospital: "",
      email: "",
      phone: "",
      msg: "",

      value1: "",
      value2: "",
      value3: "",

      options1: [
        {
          value: "Mr.",
          label: "Mr.",
        },
        {
          value: "Ms.",
          label: "Ms.",
        },
        {
          value: "Mrs.",
          label: "Mrs.",
        },
        {
          value: "Dr.",
          label: "Dr.",
        },
        {
          value: "Professor",
          label: "Professor",
        },
        {
          value: "Other",
          label: "Other",
        },
      ],

      options2: [
        {
          value: "Product Information",
          label: "Product Information",
        },
        {
          value: "Technical Support",
          label: "Technical Support",
        },
        {
          value: "Investor Relations",
          label: "Investor Relations",
        },
        {
          value: "Careers",
          label: "Careers",
        },
        {
          value: "General/Other",
          label: "General/Other",
        },
      ],

      options3: [
        {
          value: "Email",
          label: "Email",
        },
        {
          value: "Phone",
          label: "Phone",
        },
        {
          value: "Text",
          label: "Text",
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    submit() {
      const that = this;
      var token = grecaptcha.getResponse();
      if (that.value1 == "") {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please select your prefix",
          btn: "OK",
        });
        return false;
      }
      if (that.name == "") {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please complete your name",
          btn: "OK",
        });
        return false;
      }
      if (that.Hospital == "") {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please complete your hospital/company",
          btn: "OK",
        });
        return false;
      }
      if (that.City == "") {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please complete your city/state",
          btn: "OK",
        });
        return false;
      }
      if (that.Country == "") {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please complete your country",
          btn: "OK",
        });
        return false;
      }
      if (!that.email.match(/^[\w\-\.]+@[\w\-\.]+(\.\w+)+$/)) {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please complete your email address",
          btn: "OK",
        });
        return false;
      }
      if (that.phone == "") {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please complete your phone number",
          btn: "OK",
        });
        return false;
      }
      if (that.value2 == "") {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please select your type of inquiry",
          btn: "OK",
        });
        return false;
      }
      if (that.msg == "") {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please complete your comment or message",
          btn: "OK",
        });
        return false;
      }
      if (that.msg.length > 300) {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "The message exceeds the word limit (300)",
          btn: "OK",
        });
        return false;
      }
      if (that.value3 == "") {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please select your preferred contact method",
          btn: "OK",
        });
        return false;
      }
      if (token == "") {
        layer.open({
          title: ["Missing Required Information", "font-weight:bold"],
          content: "Please complete the reCAPTCHA verification",
          btn: "OK",
        });
        return false;
      }
      var formData = new FormData();
      formData.append("act", "contactus");
      formData.append("prefix", that.value1);
      formData.append("name", that.name);
      formData.append("company", that.Hospital);
      formData.append("city", that.City);
      formData.append("country", that.Country);
      formData.append("email", that.email);
      formData.append("phone", that.phone);
      formData.append("inquiry", that.value2);
      formData.append("message", that.msg);
      formData.append("contacted", that.value3);
      formData.append("g-recaptcha-response", token);

      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "post",
        datatype: "json",
        data: formData,
        processData: false,
        contentType: false,
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            layer.msg(obj.message);
            setTimeout(function () {
              location.reload();
            }, "3000");
            return true;
          } else {
            layer.open({
              title: ["Missing Required Information", "font-weight:bold"],
              content: obj.message,
              btn: "OK",
            });
            return false;
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.xm = obj.data["xm"];
            that.yx = obj.data["yx"];
            that.dh = obj.data["dh"];
            that.ly = obj.data["ly"];
            that.tijiao = obj.data["tj"];
            that.touzizhe = obj.data["touzizhe"];
            that.hint1 = obj.data["rnyrhyws"];
            // that.hint2 = obj.data["xxnd"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://recaptcha.net/recaptcha/api.js";
    document.body.appendChild(script);
    this.get_fanyi();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public.scss";

.Contact_Us {
  width: 100%;

  .contact-form {
    width: $main-width;
    margin: 20px auto 100px;

    h1 {
      color: #193b95;
      font-size: 1.4rem;
      text-align: center;
    }

    .contact-input {
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;

      .selectInput {
        margin-top: 28px;
        width: 48%;
        height: 70px;
      }

      .selectInput >>> .el-input__inner {
        height: 70px !important;
        font-family: kunbo !important;
        font-size: 1.2rem !important;
      }

      input {
        margin-top: 28px;
        width: 48%;
        height: 70px;
        background: #ffffff;
        border: 1px solid #d8d8d8;
        border-radius: 5px;
        padding: 0 22px;
        font-size: 1.2rem;
        color: #c4c4c4;
        font-family: kunbo;
      }

      .Hospital {
        width: 100%;
      }

      input::-webkit-input-placeholder {
        font-size: 1.2rem;
        color: #c4c4c4;
        font-family: kunbo;
      }

      .liuyan::-webkit-input-placeholder {
        font-size: 1.2rem;
        color: #c4c4c4;
        font-family: kunbo;
      }

      .liuyan {
        margin-top: 28px;
        width: 100%;
        height: 168px;
        background: #ffffff;
        border: 1px solid #d8d8d8;
        border-radius: 5px;
        padding: 10px 22px;
        font-size: 1.2rem;
        font-family: kunbo;
        color: #c4c4c4;
      }
    }

    .submit {
      display: block;
      width: 300px;
      margin: 60px auto;
      padding: 16px 0;
      text-align: center;
      background: #f8ad17;
      border-radius: 5px;
      color: #fff;
      font-size: 1.5rem;
      font-family: kunbo;
      cursor: pointer;
    }

    .contact-hint {
      text-align: center;

      h1 {
        margin: 14px 0;
        color: #2093d7;
        font-size: 1.3rem;
      }
    }
    .layui-layer-title {
      font-weight: bold !important;
    }
  }

  .g-recaptcha {
    margin-top: 28px;
  }
}

@media screen and (max-width: $main-width) {
  .ContactUs {
    .contact-form {
      width: 100%;
      padding: 0 10px;

      .contact-input {
        flex-direction: column;

        input {
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeContact.vue